import apiRequest from './apiRequest';

const BSheetApi = {
    createBalanceSheets(plData,accountId, token) {
        return apiRequest(`/api/balance-sheets/sheet?accountId=${encodeURIComponent(accountId)}`, 'POST', token, plData);
    },

     getBalanceSheetsMonthWise(token, accountId, start, end) {
  const url = `/api/balance-sheets/month-wise?accountId=${encodeURIComponent(accountId)}&startDate=${start}&endDate=${end}`;
  return apiRequest(url, 'GET', token);
},

  //   updateBalanceSheets(id, token, plData) {
  //       return apiRequest(`/api/balance-sheets/${id}`, 'PUT', token, plData);
  //   },


  //   getAllBalanceSheets(token) {
  //       return apiRequest('/api/balance-sheets', 'GET', token);
  //   },

  //    deleteBalanceSheets(id, token) {
  //       return apiRequest(`/api/balance-sheets/${id}`, 'DELETE', token);
  //   }, 

  //   getBalanceSheetsById(id, token) {
  //       return apiRequest(`/api/balance-sheets/${id}`, 'GET', token);
  //   },
  //   searchBalanceSheets(token, companyId, year) {
  //   const url = `/api/balance-sheets/search?companyId=${encodeURIComponent(companyId)}&year=${year}`;
  //   return apiRequest(url, 'GET', token);
  // },


  // getBalanceSheetYearlySummary(token, accountId, year) {
  //   const url = `/api/balance-sheets/report/yearly-summary?accountId=${encodeURIComponent(accountId)}&year=${year}`;
  //   return apiRequest(url, 'GET', token);
  // },

  // getBalanceSheetPeriodSummary(token, accountId, startPeriod, endPeriod) {
  //   const url = `/api/balance-sheets/report/period-summary?accountId=${encodeURIComponent(accountId)}&startPeriod=${startPeriod}&endPeriod=${endPeriod}`;
  //   return apiRequest(url, 'GET', token);
  // },

};

export default BSheetApi;
